// @core/api/endpoints/license/update_license_entitlements.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
  UpdateLicenseEntitlementsRequest,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Update license entitlements
 * Updates the entitlements (products, features, limits) for a license. Generates a new signed payload with updated entitlements. Master-only operation.
 */
export async function UpdateLicenseEntitlements(
  license_id: string,
  data: UpdateLicenseEntitlementsRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/entitlements`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.put<LicenseResponse>(requestPath, data, requestOptions);
}
